var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { helperFormat } from '@monorepo-web/utils';
import { PDFDocument } from 'pdf-lib';
/**
 * Gera uma lista com os gráficos que estarão no PDF e um valor para indicar se estão carregados ou não
 * @param pageData dados das páginas
 * @param abas Lista com as páginas do PDF
 * @param preferenceCustomizacao Customizações do cliente
 * @returns Objeto com os gráficos do PDF. A chave é o nome do gráfico e o valor indica se ele está carregado ou não
 */
export function listarGraficos(pageData, abas, preferenceCustomizacao) {
    var _a, _b, _c, _d, _e;
    const listaGraficos = {};
    if (abas === null || abas === void 0 ? void 0 : abas.includes('ResCart')) {
        if (((_a = pageData === null || pageData === void 0 ? void 0 : pageData.ResCart) === null || _a === void 0 ? void 0 : _a.pieChartClassData) &&
            pageData.ResCart.pieChartClassData.length > 0 &&
            !isNaN(pageData.ResCart.pieChartClassData[0].value)) {
            listaGraficos.graficoClasse = false;
        }
        if (((_b = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.ResCart_mostrarGraficoAlocacao) !== null && _b !== void 0 ? _b : true) &&
            ((_c = pageData === null || pageData === void 0 ? void 0 : pageData.ResCart) === null || _c === void 0 ? void 0 : _c.pieChartCustodianteData) &&
            pageData.ResCart.pieChartCustodianteData.length > 0 &&
            !isNaN(pageData.ResCart.pieChartCustodianteData[0].value)) {
            listaGraficos.graficoCustodiante = false;
        }
    }
    if (abas === null || abas === void 0 ? void 0 : abas.includes('PerfHist')) {
        listaGraficos.linhaRetorno = false;
        if (!((_d = preferenceCustomizacao === null || preferenceCustomizacao === void 0 ? void 0 : preferenceCustomizacao.PerfHist_removerGrafEvPatrimonio) !== null && _d !== void 0 ? _d : false)) {
            listaGraficos.areaPatrimonio = false;
        }
        listaGraficos.barraFinanceiro = false;
    }
    if (abas === null || abas === void 0 ? void 0 : abas.includes('CartExp')) {
        if (((_e = pageData.CartExp) === null || _e === void 0 ? void 0 : _e.pieChartClasseData) && pageData.CartExp.pieChartClasseData.length > 0 && !isNaN(pageData.CartExp.pieChartClasseData[0].value)) {
            listaGraficos.pizzaCartExp = false;
        }
    }
    return listaGraficos;
}
/**
 * Obtem os elementos HTML/SVG de uma determinada página
 * @param graficos Array com todos os gráficos
 * @param containerRefs Referência para os gráficos HTML
 * @param nomePagina Página dos gráficos
 * @returns Objeto com os elementos HTML/SVG. A chave é o nome do gráfico
 */
export function getHTMLElements(graficos, containerRefs, nomePagina, theme) {
    var _a;
    return (_a = graficos.filter((grafico) => grafico.page === nomePagina)) === null || _a === void 0 ? void 0 : _a.reduce((acc, grafico) => {
        acc[grafico.name] = grafico.type === "svg" ? getSvgFromRecharts(containerRefs.current[grafico.name], theme) : containerRefs.current[grafico.name];
        return acc;
    }, {});
}
/**
 * Obtem o elemento SVG do gráfico gerado pelo Recharts
 * @param el Elemento HTML
 * @param theme Tema
 *
 * @returns SVG com a fonte-family Roboto e fontSize
 */
export function getSvgFromRecharts(el, theme) {
    if (el) {
        const svg = el.querySelector('svg');
        // adicionar fonte 'Roboto' no elemento svg
        if (svg instanceof SVGElement) {
            const style = document.createElementNS('http://www.w3.org/2000/svg', 'style');
            style.textContent = `
              text {
                font-family: Roboto-Regular, Roboto-Bold;
                font-size: ${theme.xlFontSizePDF}px;
              }
            `;
            svg.appendChild(style);
        }
        return svg;
    }
    else {
        return null;
    }
}
/**
 * Formata as datas do PDF
 * @param obj_datas Datas
 * @returns Objeto com as datas formatadas
 */
export function generateDatasPDF(obj_datas) {
    var _a, _b, _c, _d;
    const datasIni = (_b = (_a = obj_datas === null || obj_datas === void 0 ? void 0 : obj_datas.data_ini) === null || _a === void 0 ? void 0 : _a.split('/')) !== null && _b !== void 0 ? _b : ['-', '-', '-'];
    const data_iniPDF = `_${datasIni[2]}${datasIni[1]}${datasIni[0]}`;
    const datasFim = (_d = (_c = obj_datas === null || obj_datas === void 0 ? void 0 : obj_datas.data_fim) === null || _c === void 0 ? void 0 : _c.split('/')) !== null && _d !== void 0 ? _d : ['-', '-', '-'];
    const data_fimPDF = `_${datasFim[2]}${datasFim[1]}${datasFim[0]}`;
    const data_analise = {
        ini: datasIni[0] + '/' + datasIni[1] + '/' + datasIni[2],
        fim: datasFim[0] + '/' + datasFim[1] + '/' + datasFim[2]
    };
    const dataAtual_timezone = new Date().toLocaleString("en-US", { timeZone: "America/Sao_Paulo" });
    const dataAtual = new Date(dataAtual_timezone);
    const anoElaboracao = dataAtual.getFullYear().toString();
    const mesElaboracao = (dataAtual.getMonth() + 1).toString().padStart(2, '0');
    const diaElaboracao = dataAtual.getDate().toString().padStart(2, '0');
    const dataElaboracao = '_' + anoElaboracao + mesElaboracao + diaElaboracao;
    const dataElaboracaoRodape = diaElaboracao + '/' + mesElaboracao + '/' + anoElaboracao;
    return {
        datasIni,
        datasFim,
        data_iniPDF,
        data_fimPDF,
        data_analise,
        dataElaboracao,
        dataElaboracaoRodape
    };
}
/**
 * Adiciona índice alfabetico no início de cada nome, no formato "A. nome"
 * @param data
 * @returns Dados com o campo name formatado
 */
export function addAlphaIndex(data) {
    return data.map((item, index) => (Object.assign(Object.assign({}, item), { name: String.fromCharCode(('A'.charCodeAt(0) + index % 26)) + '. ' + item.name })));
}
/**
 * Gera a legenda dos gráficos
 * @param data Informações da legenda
 * @param arrayCores Cores utilizadas para cada elemento
 * @param styles Estilo do texto da legenda
 * @param sizeRow Quantidade de itens por linha
 * @param atributes Se a legenda possuir mais de um campo por item, é necessário passar quais são os atributos como array
 * @param moneyPrefix Unidade monetária. Utilizada no volume custodiante
 *
 * @returns Linhas da tabela para gerar a legenda
 */
export function formatLegendData(data, arrayCores, styles, sizeRow, atributes, moneyPrefix) {
    if (!data)
        return [];
    const rows = [];
    let rowTemp = [];
    for (let i = 0; i < data.length; ++i) {
        // adiciona box com cor
        rowTemp.push({
            content: '',
            styles: {
                fillColor: data[i].color || arrayCores[i % arrayCores.length],
                lineColor: '#FFFFFF',
                cellWidth: 5.4,
                lineWidth: 2,
            },
        });
        if (atributes) { // adiciona todos os atributos do item na linha
            for (const [atribute, formatTypes] of atributes) {
                if (atribute in data[i]) {
                    rowTemp.push({
                        content: helperFormat(data[i][atribute], formatTypes, 2, moneyPrefix),
                        styles: styles[atribute],
                    });
                }
            }
        }
        else { // adiciona o elemento diretamente
            rowTemp.push({
                content: data[i],
                styles,
            });
        }
        if ((i + 1) % sizeRow === 0 || i === data.length - 1) { // adiciona {sizeRow} items por linha
            rows === null || rows === void 0 ? void 0 : rows.push(rowTemp);
            rowTemp = [];
        }
    }
    return rows;
}
/**
 * Gera a tabela com um box lateral com cores
 * @param rows Linhas
 * @param cols Colunas (Utilizadas para determinar ordem dos elementos da linha)
 * @param theme Tema
 * @param cellWidth Tamanho da linha
 * @param rowSpan Quantas linhas o box lateral vai ocupar
 * @param contentAttribute Se o box lateral tiver um texto, essa variável indica qual é o atributo que contém o text
 * @param fillColor Cor do box lateral. Se não passaruma cor, utiliza o chartColors
 * @returns Body com box lateral colorido
 */
export function gerarBodyComCor(rows, cols, theme, cellWidth = 1, rowSpan = 1, contentAttribute, fillColor, generateStyle) {
    const rowsColor = [];
    const lineFillColor = (row) => {
        if (Object.hasOwn(row, 'colorIndex')) {
            if (row.colorIndex === false)
                return '#D9D9D9';
            if (typeof row.colorIndex == 'number')
                return theme.chartColors[row.colorIndex % theme.chartColors.length];
        }
        return '';
    };
    for (let i = 0; i < (rows === null || rows === void 0 ? void 0 : rows.length); i++) {
        const rowTemp = [];
        const colorStyles = {
            valign: 'middle',
            halign: 'center',
            textColor: '#FFFFFF',
            lineColor: '#FFFFFF',
            lineWidth: 1,
            fillColor: fillColor !== null && fillColor !== void 0 ? fillColor : lineFillColor(rows[i]),
            cellWidth,
        };
        let text = '';
        if (contentAttribute) {
            text = rows[i][contentAttribute];
        }
        if (contentAttribute && text || !contentAttribute) { // se possui texto no box color, ele não pode ser vazio
            rowTemp.push({
                content: text,
                rowSpan,
                styles: colorStyles,
            });
        }
        // utiliza as colunas para adicionar os campos na mesma ordem
        cols === null || cols === void 0 ? void 0 : cols.forEach((col) => {
            let styles = {
                halign: col.align || 'left',
            };
            if (generateStyle) {
                styles = Object.assign(Object.assign({}, styles), generateStyle(rows[i]));
            }
            rowTemp.push({ content: rows[i][col.id], styles });
        });
        rowsColor.push(rowTemp);
    }
    return rowsColor;
}
/**
 * Obtem qual é a unidade monetária da carteira
 * @param carteiraList Lista das carteiras do usuário
 * @param carteira Carteira da caonsulta
 * @returns Unidade monetária
 */
export function getMoneyPrefix(carteiraList, carteira) {
    if (carteiraList && carteiraList[0] && carteira) {
        const carteira_result = carteiraList.filter((item) => item.nome_portfolio.toUpperCase() === carteira.toUpperCase());
        if (carteira_result[0]) {
            if (carteira_result[0].unidade_monetaria === 'EUR' || carteira_result[0].moeda === '&#8364') {
                return "€";
            }
            else {
                return carteira_result[0].moeda;
            }
        }
    }
    return 'R$';
}
/**
 * Padronização para pdf-lib
 */
function toUint8Array(parte) {
    if (typeof parte === 'string') {
        const len = parte.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = parte.charCodeAt(i);
        }
        return bytes;
    }
    else if (parte instanceof ArrayBuffer) {
        return new Uint8Array(parte);
    }
    else {
        throw new Error('Falha ao concatenar PDF.');
    }
}
/**
 * Concatena capa com o resto do PDF, e retorna resultado final
 */
export function montarPDFCustomizado(partes) {
    return __awaiter(this, void 0, void 0, function* () {
        const widthA4 = 595.28; // 210 mm
        const heightA4 = 841.89; // 297 mm
        const finalDoc = yield PDFDocument.create();
        if (partes.length === 0)
            throw new Error('Falha ao concatenar PDF.');
        const adicionarPaginas = (input, startPage = 0) => __awaiter(this, void 0, void 0, function* () {
            const totalPages = input.getPageCount();
            for (let i = startPage; i < totalPages; i++) {
                const [page] = yield finalDoc.copyPages(input, [i]);
                // Ajusta para A4 (caso seja menor ou maior do que o esperado)
                const scaleX = widthA4 / page.getWidth();
                const scaleY = heightA4 / page.getHeight();
                const scaleFactor = Math.min(scaleX, scaleY);
                page.scale(scaleX, scaleY);
                if (scaleFactor < 1) {
                    const offsetX = (widthA4 - page.getWidth()) / 2;
                    const offsetY = (heightA4 - page.getHeight()) / 2;
                    page.translateContent(offsetX, offsetY);
                }
                finalDoc.addPage(page);
            }
        });
        // Adição das páginas
        for (const parte of partes) {
            const buffer = toUint8Array(parte);
            const pdf = yield PDFDocument.load(buffer);
            yield adicionarPaginas(pdf);
        }
        const finalBytes = yield finalDoc.save();
        return new Blob([finalBytes], { type: 'application/pdf' });
    });
}
